<template>
    <div class="searchBox">
        <div class="logo">
        <icon-logo @click="gohome()"/>
        </div>
        <div class="input_area">
            <div class="search_input">
                <form @submit.prevent="postSearch" class="search-bar">
                    <input type="text" placeholder="검색어를 입력해주세요." v-model="search" pattern=".*\S.*" required>
                 </form>    
            </div>
            <div class="searchglass" @click="postSearch()">
                <icon-searchglass/>
            </div>
        </div>
    </div>
</template>
<script>
import IconLogo from '@/mobile/components/icon/LogoIconOnly'
import IconSearchglass from '@/mobile/components/icon/SearchGlass'
export default {
    name:'mobile_searchbox',
    data()
	{
		return{
			search:''
		}
	},
    components:{
        IconLogo,IconSearchglass
    },
    methods:{
        gohome(){
            this.$store.commit('menu/setSwiperIndexHome',0);
            this.$router.push({name:'m_Home'});//, params:{init_swiper:true}}
            //window.location.reload();
        },
        postSearch(){
			this.$router.push({ name: 'm_postsearch', params: { search: this.search }})
		}
    }    
}
</script>
<style lang="scss" scoped>
.searchBox{
    padding: 0.5em;
    display: flex;
    font-family: nanumgothic;
    
    .input_area{
        width: calc(100% - 40px);
        display: flex;
        justify-content: space-between;
        .search_input{
            flex-grow: 1;
            input{
                height:40px;
                font-size: 16px;  
                width: 100%;
                border: none;        
                   
            }
            input::placeholder{
                color:rgb(209, 209, 209);
            }  
        }
        .searchglass{
            display: flex;
            align-items: center;
            padding-right:10px;
        }
    }
   
}
</style>